import styled from 'styled-components';
import Stepper from '@mui/material/Stepper';
import Box from '@mui/material/Box';

export const FullHeightBox = styled(Box)`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  padding: 0.5em;
  /* reserva espaco para o rodape fixo (FooterButtons) para que os datagrids/tabelas
     terminem SEMPRE acima dos botoes Voltar/Proximo, sem esconder informacao */
  padding-bottom: 120px;
`;

export const StyledStepper = styled(Stepper)`
  margin-bottom: 30px;
`;

export const FooterButtons = styled.div`
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    max-width: 100vw;
    padding: 16px;
    display: flex;
    justify-content: space-between;
    border-top: 1px solid #ccc;
    box-sizing: border-box;
    padding-left: 320px;
    padding-right: 220px;
    z-index: 1000;
    background-color: #F3F3F1;
`;


